export { useAnchorPosition } from '../internal/use-anchor-position';
